if (!String.prototype.count)
{
    String.prototype.count = function(arg)
    {
        let count = 0;

        if(typeof arg === 'function')
        {
            for (let char of this)
            {
                if (arg(char))
                {
                    count++;
                }
            }
        }
        else if(typeof arg === 'string')
        {
            for (let char of this)
            {
                if (char === arg)
                {
                    count++;
                }
            }
        }

        return count;
    };
}
